import React, { forwardRef, useState } from 'react';
const HdfcPaymentButton = forwardRef((props, ref) => {
  const {
    amount,
    customerId,
    customerEmail,
    payment_page_client_id,
    customerPhone,
    returnUrl,
    action,
    firstName,
    AccidentVehicleCode,
    vendorcode,
    vendorType,
    description,
    orderId,
    vehicleNo
  } = props;
  const [isLoading, setIsLoading] = useState(false);

  const handlePay = async () => {
    setIsLoading(true);

    const orderData = {
      order_id: orderId,
      amount,
      customer_id: customerId,
      customer_email: customerEmail,
      customer_phone: customerPhone,
      return_url: returnUrl,
      description,
      first_name: firstName,
      payment_page_client_id,
      action
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/create-session/${AccidentVehicleCode}/${vendorcode}/${vendorType}/${vehicleNo}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(orderData)
      });

      const data = await res.json();
      console.log(data);

      if (data.paymentLink) {
        window.location.href = data.paymentLink;
      } else {
        alert("Error creating payment session.");
      }
    } catch (err) {
      alert("Payment error: " + err.message);
    } finally {
      // setIsLoading(false);
    }
  };

  return (
    <button ref={ref} onClick={handlePay} disabled={isLoading}>
      {isLoading ? "Processing..." : "Pay With HDFC Payment Gateway"}
    </button>


  );
})

export default HdfcPaymentButton;
